<template>
  <div class="app-container">
    <div class="content-box">
      <el-button type="primary" @click="getReboot" style="background:#f06400;border-color: #f06400; ">重启</el-button>
    </div>
  </div>
</template>
<script>
import { operationReboot } from "@/api/devices/devices.js";
export default {
  props: ["queryDataList"],
  data() {
    return {
      rebootOne: "",
      //query_data:{}
    };
  },
  watch: {
    queryDataList(n, o) {
      this.rebootOne = n;
    },
  },

  created() {
    this.rebootOne = this.queryDataList;
  },

  methods: {
    getReboot() {
      this.$confirm("是否重启", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let paramValue = new FormData();
          paramValue.append("deviceId", this.rebootOne.id);
          operationReboot(paramValue).then((res) => {
            console.log(res,122121)
            if (res.code == "0") {
              this.$message({
                message: "提交请求成功",
                type: "success",
              });
              this.$router.push("/equipmentManagement/taskList");
            } else {
              this.$message({
                message: res.msg,
                type: "error",
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.content-box{
margin-top: 10px;
margin-left: 30px;
height: 100vh;
}

</style>